// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bi-root {
  --bi-ink: #101820;
  --bi-paper: #e8eeea;
  --bi-panel: #fbfcfb;
  --bi-line: #c5d0ca;
  --bi-signal: #0a8f8a;
  --bi-signal-deep: #066666;
  --bi-warn: #b45309;
  --bi-muted: #5a6a64;
  --bi-glow: rgba(10, 143, 138, 0.14);
  --bi-display: "Bebas Neue", "Arial Narrow", Impact, sans-serif;
  --bi-sans: "IBM Plex Sans", "Segoe UI", sans-serif;
  --bi-mono: "IBM Plex Mono", ui-monospace, monospace;

  font-family: var(--bi-sans);
  color: var(--bi-ink);
  background:
    radial-gradient(900px 420px at 8% -8%, var(--bi-glow), transparent 58%),
    radial-gradient(700px 360px at 92% 0%, rgba(16, 24, 32, 0.05), transparent 50%),
    linear-gradient(165deg, #dde6e1 0%, var(--bi-paper) 42%, #e4ebe7 100%);
  min-height: calc(100vh - 72px);
  margin: -8px -12px 0;
  padding: 22px 18px 44px;
  box-sizing: border-box;
}

.bi-pad {
  padding: 12px 14px;
}

.bi-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px 28px;
  margin-bottom: 18px;
  padding: 2px 2px 16px;
  border-bottom: 2px solid var(--bi-ink);
  animation: bi-rise 0.45s ease both;
}

.bi-hero__eyebrow {
  font-family: var(--bi-mono);
  font-size: 0.7rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--bi-signal-deep);
  margin: 0 0 6px;
}

.bi-hero__title {
  font-family: var(--bi-display);
  font-size: clamp(2.5rem, 5.2vw, 3.75rem);
  line-height: 0.9;
  letter-spacing: 0.02em;
  margin: 0;
  font-weight: 400;
}

.bi-hero__sub {
  margin: 10px 0 0;
  max-width: 36rem;
  color: var(--bi-muted);
  font-size: 0.94rem;
  line-height: 1.45;
}

.bi-hero__stat {
  text-align: right;
  min-width: 7rem;
  padding-bottom: 2px;
}

.bi-hero__stat-k {
  display: block;
  font-family: var(--bi-mono);
  font-size: 0.68rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--bi-muted);
}

.bi-hero__stat-v {
  font-family: var(--bi-display);
  font-size: 2.6rem;
  line-height: 0.9;
  letter-spacing: 0.02em;
}

.bi-shell {
  display: grid;
  grid-template-columns: minmax(260px, 312px) minmax(0, 1fr);
  gap: 16px;
  align-items: start;
  animation: bi-rise 0.55s ease 0.06s both;
}

.bi-rail,
.bi-stage {
  background: var(--bi-panel);
  border: 1px solid var(--bi-line);
  box-shadow: 0 12px 32px rgba(16, 24, 32, 0.06);
}

.bi-rail {
  position: sticky;
  top: 12px;
  max-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.bi-rail__head {
  padding: 14px 14px 10px;
  border-bottom: 1px solid var(--bi-line);
}

.bi-rail__label {
  font-family: var(--bi-mono);
  font-size: 0.68rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--bi-muted);
  margin: 0 0 8px;
}

.bi-rail__search {
  width: 100%;
  border: 1px solid var(--bi-line);
  background: #f3f7f5;
  padding: 9px 11px;
  font: 500 0.9rem/1.2 var(--bi-sans);
  color: var(--bi-ink);
  outline: none;
  box-sizing: border-box;
}

.bi-rail__search:focus {
  border-color: var(--bi-signal);
  box-shadow: 0 0 0 3px var(--bi-glow);
}

.bi-rail__list {
  list-style: none;
  margin: 0;
  padding: 8px;
  overflow: auto;
  flex: 1 1;
}

.bi-club {
  width: 100%;
  text-align: left;
  border: 1px solid transparent;
  background: transparent;
  padding: 11px 10px 10px;
  margin-bottom: 6px;
  cursor: pointer;
  transition:
    border-color 0.18s ease,
    background 0.18s ease,
    transform 0.18s ease;
}

.bi-club:hover {
  border-color: var(--bi-line);
  background: #f4f8f6;
}

.bi-club.is-active {
  border-color: var(--bi-ink);
  background: linear-gradient(145deg, #f2faf9 0%, #e9f4f2 100%);
  transform: translateX(3px);
}

.bi-club__row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.bi-club__name {
  font-weight: 650;
  font-size: 0.95rem;
  margin: 0;
  line-height: 1.25;
}

.bi-club__usd {
  font-family: var(--bi-mono);
  font-size: 0.72rem;
  color: var(--bi-signal-deep);
  white-space: nowrap;
}

.bi-club__meta {
  font-family: var(--bi-mono);
  font-size: 0.68rem;
  color: var(--bi-muted);
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
  margin-top: 6px;
}

.bi-club__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--bi-line);
  display: inline-block;
  margin-right: 6px;
  vertical-align: middle;
}

.bi-club__dot.is-live {
  background: var(--bi-signal);
  box-shadow: 0 0 0 3px var(--bi-glow);
  animation: bi-pulse 2.2s ease infinite;
}

.bi-bar {
  display: block;
  height: 3px;
  background: #e2eae6;
  overflow: hidden;
}

.bi-bar__fill {
  display: block;
  height: 100%;
  max-width: 100%;
  transition: width 0.35s ease;
}

.bi-bar__fill--signal {
  background: var(--bi-signal);
}

.bi-bar__fill--ink {
  background: var(--bi-ink);
}

.bi-stage {
  min-height: 540px;
  padding: 0;
  overflow: hidden;
}

.bi-empty {
  padding: 64px 32px;
  text-align: center;
}

.bi-empty__title {
  font-family: var(--bi-display);
  font-size: 2rem;
  letter-spacing: 0.03em;
  margin: 0 0 8px;
}

.bi-empty__sub {
  margin: 0 auto;
  max-width: 22rem;
  color: var(--bi-muted);
  font-size: 0.92rem;
  line-height: 1.45;
}

.bi-stage__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--bi-line);
  background:
    linear-gradient(90deg, #f4f9f7 0%, #f8faf8 55%, #f3f6f4 100%);
}

.bi-stage__kicker {
  font-family: var(--bi-mono);
  font-size: 0.64rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--bi-muted);
  margin: 0 0 4px;
}

.bi-stage__club {
  font-family: var(--bi-display);
  font-size: clamp(1.7rem, 3vw, 2.1rem);
  letter-spacing: 0.03em;
  margin: 0;
  line-height: 0.95;
}

.bi-week {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--bi-mono);
  font-size: 0.78rem;
}

.bi-week button {
  border: 1px solid var(--bi-ink);
  background: #fff;
  color: var(--bi-ink);
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
}

.bi-week button:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.bi-week__label {
  min-width: 9.5rem;
  text-align: center;
  padding: 0 6px;
}

.bi-banner {
  margin: 0;
  padding: 10px 16px;
  background: #fff7ed;
  color: var(--bi-warn);
  font-size: 0.86rem;
  border-bottom: 1px solid #f3e0c7;
}

.bi-meters {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1px;
  background: var(--bi-line);
  border-bottom: 1px solid var(--bi-line);
}

.bi-meters.is-refreshing {
  opacity: 0.72;
  transition: opacity 0.2s ease;
}

.bi-meters--skel {
  background: transparent;
  gap: 0;
  border-bottom: 1px solid var(--bi-line);
}

.bi-meter {
  background: var(--bi-panel);
  padding: 16px 14px 14px;
  min-height: 100px;
}

.bi-meter__k {
  font-family: var(--bi-mono);
  font-size: 0.66rem;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: var(--bi-muted);
  margin: 0 0 8px;
}

.bi-meter__v {
  font-family: var(--bi-display);
  font-size: clamp(1.85rem, 3vw, 2.5rem);
  line-height: 0.94;
  margin: 0;
  letter-spacing: 0.02em;
}

.bi-meter__v.is-signal {
  color: var(--bi-signal-deep);
}

.bi-meter__h {
  margin: 7px 0 0;
  font-size: 0.76rem;
  color: var(--bi-muted);
  line-height: 1.3;
}

.bi-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  border-bottom: 1px solid var(--bi-line);
  padding: 0 8px;
  background: #f1f6f3;
}

.bi-tab {
  border: 0;
  background: transparent;
  padding: 13px 14px;
  font: 600 0.86rem/1 var(--bi-sans);
  color: var(--bi-muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 0.15s ease;
}

.bi-tab:hover {
  color: var(--bi-ink);
}

.bi-tab.is-active {
  color: var(--bi-ink);
  border-bottom-color: var(--bi-signal);
}

.bi-panel {
  padding: 18px 16px 20px;
}

.bi-panel--enter {
  animation: bi-fade 0.28s ease both;
}

.bi-facts {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
}

.bi-fact {
  border: 1px solid var(--bi-line);
  padding: 12px 12px 11px;
  background: #f7faf8;
}

.bi-fact--wide {
  grid-column: 1 / -1;
}

.bi-fact__k {
  display: block;
  font-family: var(--bi-mono);
  font-size: 0.64rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--bi-muted);
  margin-bottom: 6px;
}

.bi-fact__v {
  font-family: var(--bi-mono);
  font-size: 1.05rem;
  font-variant-numeric: tabular-nums;
}

.bi-fact__v--text {
  font-family: var(--bi-sans);
  font-size: 0.92rem;
  font-weight: 500;
}

.bi-ranks {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.bi-rank {
  display: grid;
  grid-template-columns: 2rem minmax(0, 1fr);
  gap: 10px;
  align-items: start;
  padding: 10px 10px 11px;
  border: 1px solid var(--bi-line);
  background: #fff;
}

.bi-rank__idx {
  font-family: var(--bi-mono);
  font-size: 0.72rem;
  color: var(--bi-muted);
  padding-top: 3px;
}

.bi-rank__top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 7px;
}

.bi-rank__title {
  font-weight: 600;
  font-size: 0.92rem;
  line-height: 1.25;
  word-break: break-word;
}

.bi-rank__val {
  font-family: var(--bi-mono);
  font-size: 0.8rem;
  color: var(--bi-signal-deep);
  white-space: nowrap;
}

.bi-rank__meta {
  margin: 6px 0 0;
  font-size: 0.76rem;
  color: var(--bi-muted);
  line-height: 1.35;
}

.bi-split {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px 18px;
}

.bi-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.bi-btn {
  border: 1px solid var(--bi-ink);
  background: var(--bi-ink);
  color: #fff;
  padding: 9px 14px;
  font: 600 0.84rem/1.1 var(--bi-sans);
  cursor: pointer;
}

.bi-btn--ghost {
  background: #fff;
  color: var(--bi-ink);
}

.bi-btn--compact {
  height: 30px;
  padding: 0 10px;
  font-size: 0.78rem;
}

.bi-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.bi-champ {
  max-width: 36rem;
}

.bi-champ__title {
  font-family: var(--bi-display);
  font-size: 1.55rem;
  letter-spacing: 0.03em;
  margin: 0 0 6px;
}

.bi-champ__desc {
  margin: 0 0 14px;
  color: var(--bi-muted);
  font-size: 0.86rem;
}

.bi-champ label {
  display: block;
  font-size: 0.82rem;
  color: var(--bi-muted);
  margin-bottom: 10px;
}

.bi-champ input {
  display: block;
  width: 100%;
  margin-top: 4px;
  border: 1px solid var(--bi-line);
  padding: 8px 10px;
  font: 500 0.9rem/1.2 var(--bi-sans);
  box-sizing: border-box;
  background: #fff;
}

.bi-champ input:focus {
  outline: none;
  border-color: var(--bi-signal);
  box-shadow: 0 0 0 3px var(--bi-glow);
}

.bi-error {
  color: #b91c1c;
  font-size: 0.88rem;
  margin: 0;
}

.bi-muted {
  color: var(--bi-muted);
  font-size: 0.88rem;
}

.bi-skel {
  display: block;
  background: linear-gradient(90deg, #e8eeea 20%, #f4f7f5 50%, #e8eeea 80%);
  background-size: 200% 100%;
  animation: bi-shimmer 1.1s linear infinite;
}

.bi-skel--club {
  height: 72px;
  margin-bottom: 8px;
}

.bi-skel--meter {
  height: 100px;
  border-right: 1px solid var(--bi-line);
}

@keyframes bi-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes bi-fade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes bi-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 3px var(--bi-glow);
  }
  50% {
    box-shadow: 0 0 0 5px rgba(10, 143, 138, 0.08);
  }
}

@keyframes bi-shimmer {
  from {
    background-position: 100% 0;
  }
  to {
    background-position: -100% 0;
  }
}

@media (max-width: 980px) {
  .bi-shell {
    grid-template-columns: 1fr;
  }

  .bi-rail {
    position: static;
    max-height: 300px;
  }

  .bi-meters {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 820px) {
  .bi-meters {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bi-facts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .bi-split {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .bi-root {
    margin: 0;
    padding: 12px 10px 28px;
  }

  .bi-meters,
  .bi-facts {
    grid-template-columns: 1fr;
  }

  .bi-hero__stat {
    text-align: left;
  }
}

@media (prefers-reduced-motion: reduce) {
  .bi-club,
  .bi-bar__fill,
  .bi-tab,
  .bi-meters.is-refreshing {
    transition: none;
  }

  .bi-hero,
  .bi-shell,
  .bi-panel--enter,
  .bi-club__dot.is-live,
  .bi-skel {
    animation: none;
  }
}

/* Capture QoS dashboard */
.bi-panel__title {
  font-family: var(--bi-mono);
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin: 0 0 10px;
  color: var(--bi-signal-deep);
}

.bi-grid {
  display: grid;
  gap: 12px;
}

.bi-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.bi-metric {
  font-family: var(--bi-display);
  font-size: 2.4rem;
  line-height: 1;
  margin: 0 0 8px;
}

.bi-btn--primary {
  background: var(--bi-ink);
  color: #fff;
  border-color: var(--bi-ink);
}

.bi-chip {
  font-family: var(--bi-mono);
  font-size: 0.68rem;
  border: 1px solid var(--bi-line);
  background: #fff;
  padding: 3px 7px;
  cursor: pointer;
}

.bi-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.bi-table th,
.bi-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid var(--bi-line);
  vertical-align: top;
}

.bi-table th {
  font-family: var(--bi-mono);
  font-size: 0.68rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--bi-muted);
}

@media (max-width: 800px) {
  .bi-grid--3 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/superadmin/BusinessIntelligence.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,8DAA8D;EAC9D,kDAAkD;EAClD,mDAAmD;;EAEnD,2BAA2B;EAC3B,oBAAoB;EACpB;;;0EAGwE;EACxE,8BAA8B;EAC9B,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;;EAEE,2BAA2B;EAC3B,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;EACnC,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,cAAc;EACd,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf;;;wBAGsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC;iEAC+D;AACjE;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,MAAM;EACN,uCAAuC;AACzC;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,iBAAiB;EACjB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,uCAAuC;EACvC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,mCAAmC;EACnC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yEAAyE;EACzE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,oCAAoC;EACtC;EACA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;;;IAIE,gBAAgB;EAClB;;EAEA;;;;;IAKE,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500;600;700&display=swap\");\n\n.bi-root {\n  --bi-ink: #101820;\n  --bi-paper: #e8eeea;\n  --bi-panel: #fbfcfb;\n  --bi-line: #c5d0ca;\n  --bi-signal: #0a8f8a;\n  --bi-signal-deep: #066666;\n  --bi-warn: #b45309;\n  --bi-muted: #5a6a64;\n  --bi-glow: rgba(10, 143, 138, 0.14);\n  --bi-display: \"Bebas Neue\", \"Arial Narrow\", Impact, sans-serif;\n  --bi-sans: \"IBM Plex Sans\", \"Segoe UI\", sans-serif;\n  --bi-mono: \"IBM Plex Mono\", ui-monospace, monospace;\n\n  font-family: var(--bi-sans);\n  color: var(--bi-ink);\n  background:\n    radial-gradient(900px 420px at 8% -8%, var(--bi-glow), transparent 58%),\n    radial-gradient(700px 360px at 92% 0%, rgba(16, 24, 32, 0.05), transparent 50%),\n    linear-gradient(165deg, #dde6e1 0%, var(--bi-paper) 42%, #e4ebe7 100%);\n  min-height: calc(100vh - 72px);\n  margin: -8px -12px 0;\n  padding: 22px 18px 44px;\n  box-sizing: border-box;\n}\n\n.bi-pad {\n  padding: 12px 14px;\n}\n\n.bi-hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px 28px;\n  margin-bottom: 18px;\n  padding: 2px 2px 16px;\n  border-bottom: 2px solid var(--bi-ink);\n  animation: bi-rise 0.45s ease both;\n}\n\n.bi-hero__eyebrow {\n  font-family: var(--bi-mono);\n  font-size: 0.7rem;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--bi-signal-deep);\n  margin: 0 0 6px;\n}\n\n.bi-hero__title {\n  font-family: var(--bi-display);\n  font-size: clamp(2.5rem, 5.2vw, 3.75rem);\n  line-height: 0.9;\n  letter-spacing: 0.02em;\n  margin: 0;\n  font-weight: 400;\n}\n\n.bi-hero__sub {\n  margin: 10px 0 0;\n  max-width: 36rem;\n  color: var(--bi-muted);\n  font-size: 0.94rem;\n  line-height: 1.45;\n}\n\n.bi-hero__stat {\n  text-align: right;\n  min-width: 7rem;\n  padding-bottom: 2px;\n}\n\n.bi-hero__stat-k {\n  display: block;\n  font-family: var(--bi-mono);\n  font-size: 0.68rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--bi-muted);\n}\n\n.bi-hero__stat-v {\n  font-family: var(--bi-display);\n  font-size: 2.6rem;\n  line-height: 0.9;\n  letter-spacing: 0.02em;\n}\n\n.bi-shell {\n  display: grid;\n  grid-template-columns: minmax(260px, 312px) minmax(0, 1fr);\n  gap: 16px;\n  align-items: start;\n  animation: bi-rise 0.55s ease 0.06s both;\n}\n\n.bi-rail,\n.bi-stage {\n  background: var(--bi-panel);\n  border: 1px solid var(--bi-line);\n  box-shadow: 0 12px 32px rgba(16, 24, 32, 0.06);\n}\n\n.bi-rail {\n  position: sticky;\n  top: 12px;\n  max-height: calc(100vh - 100px);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.bi-rail__head {\n  padding: 14px 14px 10px;\n  border-bottom: 1px solid var(--bi-line);\n}\n\n.bi-rail__label {\n  font-family: var(--bi-mono);\n  font-size: 0.68rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--bi-muted);\n  margin: 0 0 8px;\n}\n\n.bi-rail__search {\n  width: 100%;\n  border: 1px solid var(--bi-line);\n  background: #f3f7f5;\n  padding: 9px 11px;\n  font: 500 0.9rem/1.2 var(--bi-sans);\n  color: var(--bi-ink);\n  outline: none;\n  box-sizing: border-box;\n}\n\n.bi-rail__search:focus {\n  border-color: var(--bi-signal);\n  box-shadow: 0 0 0 3px var(--bi-glow);\n}\n\n.bi-rail__list {\n  list-style: none;\n  margin: 0;\n  padding: 8px;\n  overflow: auto;\n  flex: 1;\n}\n\n.bi-club {\n  width: 100%;\n  text-align: left;\n  border: 1px solid transparent;\n  background: transparent;\n  padding: 11px 10px 10px;\n  margin-bottom: 6px;\n  cursor: pointer;\n  transition:\n    border-color 0.18s ease,\n    background 0.18s ease,\n    transform 0.18s ease;\n}\n\n.bi-club:hover {\n  border-color: var(--bi-line);\n  background: #f4f8f6;\n}\n\n.bi-club.is-active {\n  border-color: var(--bi-ink);\n  background: linear-gradient(145deg, #f2faf9 0%, #e9f4f2 100%);\n  transform: translateX(3px);\n}\n\n.bi-club__row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.bi-club__name {\n  font-weight: 650;\n  font-size: 0.95rem;\n  margin: 0;\n  line-height: 1.25;\n}\n\n.bi-club__usd {\n  font-family: var(--bi-mono);\n  font-size: 0.72rem;\n  color: var(--bi-signal-deep);\n  white-space: nowrap;\n}\n\n.bi-club__meta {\n  font-family: var(--bi-mono);\n  font-size: 0.68rem;\n  color: var(--bi-muted);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 10px;\n  margin-top: 6px;\n}\n\n.bi-club__dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--bi-line);\n  display: inline-block;\n  margin-right: 6px;\n  vertical-align: middle;\n}\n\n.bi-club__dot.is-live {\n  background: var(--bi-signal);\n  box-shadow: 0 0 0 3px var(--bi-glow);\n  animation: bi-pulse 2.2s ease infinite;\n}\n\n.bi-bar {\n  display: block;\n  height: 3px;\n  background: #e2eae6;\n  overflow: hidden;\n}\n\n.bi-bar__fill {\n  display: block;\n  height: 100%;\n  max-width: 100%;\n  transition: width 0.35s ease;\n}\n\n.bi-bar__fill--signal {\n  background: var(--bi-signal);\n}\n\n.bi-bar__fill--ink {\n  background: var(--bi-ink);\n}\n\n.bi-stage {\n  min-height: 540px;\n  padding: 0;\n  overflow: hidden;\n}\n\n.bi-empty {\n  padding: 64px 32px;\n  text-align: center;\n}\n\n.bi-empty__title {\n  font-family: var(--bi-display);\n  font-size: 2rem;\n  letter-spacing: 0.03em;\n  margin: 0 0 8px;\n}\n\n.bi-empty__sub {\n  margin: 0 auto;\n  max-width: 22rem;\n  color: var(--bi-muted);\n  font-size: 0.92rem;\n  line-height: 1.45;\n}\n\n.bi-stage__bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--bi-line);\n  background:\n    linear-gradient(90deg, #f4f9f7 0%, #f8faf8 55%, #f3f6f4 100%);\n}\n\n.bi-stage__kicker {\n  font-family: var(--bi-mono);\n  font-size: 0.64rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--bi-muted);\n  margin: 0 0 4px;\n}\n\n.bi-stage__club {\n  font-family: var(--bi-display);\n  font-size: clamp(1.7rem, 3vw, 2.1rem);\n  letter-spacing: 0.03em;\n  margin: 0;\n  line-height: 0.95;\n}\n\n.bi-week {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--bi-mono);\n  font-size: 0.78rem;\n}\n\n.bi-week button {\n  border: 1px solid var(--bi-ink);\n  background: #fff;\n  color: var(--bi-ink);\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  font-size: 1rem;\n  line-height: 1;\n}\n\n.bi-week button:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.bi-week__label {\n  min-width: 9.5rem;\n  text-align: center;\n  padding: 0 6px;\n}\n\n.bi-banner {\n  margin: 0;\n  padding: 10px 16px;\n  background: #fff7ed;\n  color: var(--bi-warn);\n  font-size: 0.86rem;\n  border-bottom: 1px solid #f3e0c7;\n}\n\n.bi-meters {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 1px;\n  background: var(--bi-line);\n  border-bottom: 1px solid var(--bi-line);\n}\n\n.bi-meters.is-refreshing {\n  opacity: 0.72;\n  transition: opacity 0.2s ease;\n}\n\n.bi-meters--skel {\n  background: transparent;\n  gap: 0;\n  border-bottom: 1px solid var(--bi-line);\n}\n\n.bi-meter {\n  background: var(--bi-panel);\n  padding: 16px 14px 14px;\n  min-height: 100px;\n}\n\n.bi-meter__k {\n  font-family: var(--bi-mono);\n  font-size: 0.66rem;\n  letter-spacing: 0.11em;\n  text-transform: uppercase;\n  color: var(--bi-muted);\n  margin: 0 0 8px;\n}\n\n.bi-meter__v {\n  font-family: var(--bi-display);\n  font-size: clamp(1.85rem, 3vw, 2.5rem);\n  line-height: 0.94;\n  margin: 0;\n  letter-spacing: 0.02em;\n}\n\n.bi-meter__v.is-signal {\n  color: var(--bi-signal-deep);\n}\n\n.bi-meter__h {\n  margin: 7px 0 0;\n  font-size: 0.76rem;\n  color: var(--bi-muted);\n  line-height: 1.3;\n}\n\n.bi-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  border-bottom: 1px solid var(--bi-line);\n  padding: 0 8px;\n  background: #f1f6f3;\n}\n\n.bi-tab {\n  border: 0;\n  background: transparent;\n  padding: 13px 14px;\n  font: 600 0.86rem/1 var(--bi-sans);\n  color: var(--bi-muted);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color 0.15s ease;\n}\n\n.bi-tab:hover {\n  color: var(--bi-ink);\n}\n\n.bi-tab.is-active {\n  color: var(--bi-ink);\n  border-bottom-color: var(--bi-signal);\n}\n\n.bi-panel {\n  padding: 18px 16px 20px;\n}\n\n.bi-panel--enter {\n  animation: bi-fade 0.28s ease both;\n}\n\n.bi-facts {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.bi-fact {\n  border: 1px solid var(--bi-line);\n  padding: 12px 12px 11px;\n  background: #f7faf8;\n}\n\n.bi-fact--wide {\n  grid-column: 1 / -1;\n}\n\n.bi-fact__k {\n  display: block;\n  font-family: var(--bi-mono);\n  font-size: 0.64rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--bi-muted);\n  margin-bottom: 6px;\n}\n\n.bi-fact__v {\n  font-family: var(--bi-mono);\n  font-size: 1.05rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.bi-fact__v--text {\n  font-family: var(--bi-sans);\n  font-size: 0.92rem;\n  font-weight: 500;\n}\n\n.bi-ranks {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.bi-rank {\n  display: grid;\n  grid-template-columns: 2rem minmax(0, 1fr);\n  gap: 10px;\n  align-items: start;\n  padding: 10px 10px 11px;\n  border: 1px solid var(--bi-line);\n  background: #fff;\n}\n\n.bi-rank__idx {\n  font-family: var(--bi-mono);\n  font-size: 0.72rem;\n  color: var(--bi-muted);\n  padding-top: 3px;\n}\n\n.bi-rank__top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 7px;\n}\n\n.bi-rank__title {\n  font-weight: 600;\n  font-size: 0.92rem;\n  line-height: 1.25;\n  word-break: break-word;\n}\n\n.bi-rank__val {\n  font-family: var(--bi-mono);\n  font-size: 0.8rem;\n  color: var(--bi-signal-deep);\n  white-space: nowrap;\n}\n\n.bi-rank__meta {\n  margin: 6px 0 0;\n  font-size: 0.76rem;\n  color: var(--bi-muted);\n  line-height: 1.35;\n}\n\n.bi-split {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 20px 18px;\n}\n\n.bi-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.bi-btn {\n  border: 1px solid var(--bi-ink);\n  background: var(--bi-ink);\n  color: #fff;\n  padding: 9px 14px;\n  font: 600 0.84rem/1.1 var(--bi-sans);\n  cursor: pointer;\n}\n\n.bi-btn--ghost {\n  background: #fff;\n  color: var(--bi-ink);\n}\n\n.bi-btn--compact {\n  height: 30px;\n  padding: 0 10px;\n  font-size: 0.78rem;\n}\n\n.bi-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.bi-champ {\n  max-width: 36rem;\n}\n\n.bi-champ__title {\n  font-family: var(--bi-display);\n  font-size: 1.55rem;\n  letter-spacing: 0.03em;\n  margin: 0 0 6px;\n}\n\n.bi-champ__desc {\n  margin: 0 0 14px;\n  color: var(--bi-muted);\n  font-size: 0.86rem;\n}\n\n.bi-champ label {\n  display: block;\n  font-size: 0.82rem;\n  color: var(--bi-muted);\n  margin-bottom: 10px;\n}\n\n.bi-champ input {\n  display: block;\n  width: 100%;\n  margin-top: 4px;\n  border: 1px solid var(--bi-line);\n  padding: 8px 10px;\n  font: 500 0.9rem/1.2 var(--bi-sans);\n  box-sizing: border-box;\n  background: #fff;\n}\n\n.bi-champ input:focus {\n  outline: none;\n  border-color: var(--bi-signal);\n  box-shadow: 0 0 0 3px var(--bi-glow);\n}\n\n.bi-error {\n  color: #b91c1c;\n  font-size: 0.88rem;\n  margin: 0;\n}\n\n.bi-muted {\n  color: var(--bi-muted);\n  font-size: 0.88rem;\n}\n\n.bi-skel {\n  display: block;\n  background: linear-gradient(90deg, #e8eeea 20%, #f4f7f5 50%, #e8eeea 80%);\n  background-size: 200% 100%;\n  animation: bi-shimmer 1.1s linear infinite;\n}\n\n.bi-skel--club {\n  height: 72px;\n  margin-bottom: 8px;\n}\n\n.bi-skel--meter {\n  height: 100px;\n  border-right: 1px solid var(--bi-line);\n}\n\n@keyframes bi-rise {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes bi-fade {\n  from {\n    opacity: 0;\n    transform: translateY(4px);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n@keyframes bi-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 3px var(--bi-glow);\n  }\n  50% {\n    box-shadow: 0 0 0 5px rgba(10, 143, 138, 0.08);\n  }\n}\n\n@keyframes bi-shimmer {\n  from {\n    background-position: 100% 0;\n  }\n  to {\n    background-position: -100% 0;\n  }\n}\n\n@media (max-width: 980px) {\n  .bi-shell {\n    grid-template-columns: 1fr;\n  }\n\n  .bi-rail {\n    position: static;\n    max-height: 300px;\n  }\n\n  .bi-meters {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 820px) {\n  .bi-meters {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .bi-facts {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .bi-split {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .bi-root {\n    margin: 0;\n    padding: 12px 10px 28px;\n  }\n\n  .bi-meters,\n  .bi-facts {\n    grid-template-columns: 1fr;\n  }\n\n  .bi-hero__stat {\n    text-align: left;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .bi-club,\n  .bi-bar__fill,\n  .bi-tab,\n  .bi-meters.is-refreshing {\n    transition: none;\n  }\n\n  .bi-hero,\n  .bi-shell,\n  .bi-panel--enter,\n  .bi-club__dot.is-live,\n  .bi-skel {\n    animation: none;\n  }\n}\n\n/* Capture QoS dashboard */\n.bi-panel__title {\n  font-family: var(--bi-mono);\n  font-size: 0.72rem;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  margin: 0 0 10px;\n  color: var(--bi-signal-deep);\n}\n\n.bi-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.bi-grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.bi-metric {\n  font-family: var(--bi-display);\n  font-size: 2.4rem;\n  line-height: 1;\n  margin: 0 0 8px;\n}\n\n.bi-btn--primary {\n  background: var(--bi-ink);\n  color: #fff;\n  border-color: var(--bi-ink);\n}\n\n.bi-chip {\n  font-family: var(--bi-mono);\n  font-size: 0.68rem;\n  border: 1px solid var(--bi-line);\n  background: #fff;\n  padding: 3px 7px;\n  cursor: pointer;\n}\n\n.bi-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.bi-table th,\n.bi-table td {\n  text-align: left;\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--bi-line);\n  vertical-align: top;\n}\n\n.bi-table th {\n  font-family: var(--bi-mono);\n  font-size: 0.68rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--bi-muted);\n}\n\n@media (max-width: 800px) {\n  .bi-grid--3 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
